export enum PreferencePeriodEnum {
    EMPTY = '',
    FALLS = 'falls',
    SPRING = 'spring',
    SUMMER = 'summer',
    WINTER = 'winter',
}
